// /src/api/UserExecutionEngine.jsx
// VERSÃO 18.5 GOLD - CENTRAL DE CONTINGENTE E COMANDO MASTER (COM RAIO-X)

import apiClient from './apiClient';
import { toast } from 'react-toastify';

export const UserExecutionEngine = {
    
    /**
     * 🛰️ EXTRAÇÃO DE CONTINGENTE ATIVO (GET)
     * Retorna a lista completa de membros ativos no Time Diplomata.
     */
    async listarContingente() {
        try {
            const { data } = await apiClient.get('/api/users'); 
            return Array.isArray(data) ? data : []; 
        } catch (error) {
            console.error("❌ [ERRO CRÍTICO]: Falha ao listar contingente:", error);
            return [];
        }
    },

    /**
     * 👥 RECRUTAMENTO: LISTAR AGENTES DISPONÍVEIS
     * Filtra e retorna apenas quem pode receber leads (Gestores e Corretores).
     */
    async listarAgentes() {
        try {
            const { data } = await apiClient.get('/api/users'); 
            // Filtro tático: Apenas cargos de linha de frente recebem leads
            if (Array.isArray(data)) {
                return data.filter(u => u.role === 'CORRETOR' || u.role === 'GESTOR' || u.role === 'MASTER');
            }
            return [];
        } catch (error) {
            console.error("❌ [ERRO]: Falha ao buscar agentes para delegação:", error);
            return [];
        }
    },

    /**
     * ⚔️ ALISTAMENTO DIRETO (POST)
     * Cria novos usuários com status ATIVO instantaneamente (Uso Master/ADM).
     */
    async alistarRecruta(userData) {
        try {
            const { data } = await apiClient.post('/api/users/admin/create-user', userData);
            toast.success("🛡️ NOVO MEMBRO ALISTADO COM SUCESSO!");
            return true;
        } catch (error) {
            console.error("❌ Falha no alistamento:", error);
            toast.error(error.response?.data?.message || "FALHA NO PROTOCOLO DE RECRUTAMENTO");
            return false;
        }
    },

    /**
     * 🛠️ EDITOR DE PERFIL (PUT)
     * Atualiza Nome, Cargo ou Senha de um membro existente.
     */
    async atualizarAgente(id, updateData) {
        try {
            // 🛡️ Blindagem de Senha: Se o campo vier vazio, removemos do payload 
            // para que o banco não salve uma string vazia como senha.
            const payload = { ...updateData };
            if (!payload.password || payload.password.trim() === '') {
                delete payload.password;
            }

            const { data } = await apiClient.put(`/api/users/${id}`, payload);
            toast.success("📝 PERFIL ATUALIZADO E SINCRONIZADO!");
            return true;
        } catch (error) {
            console.error("❌ Erro ao atualizar perfil:", error);
            toast.error("FALHA NA ATUALIZAÇÃO TÁTICA.");
            return false;
        }
    },

    /**
     * ⚰️ EXPULSÃO DEFINITIVA (DELETE)
     * Remove permanentemente o acesso do alvo ao sistema.
     */
    async expulsarAgente(id) {
        try {
            await apiClient.delete(`/api/users/${id}`);
            toast.warn("🔥 ALVO REMOVIDO DO SISTEMA DEFINITIVAMENTE.");
            return true;
        } catch (error) {
            console.error("❌ Falha na expulsão:", error);
            toast.error("ERRO AO REMOVER AGENTE DA BASE.");
            return false;
        }
    },

    /**
     * ☣️ SALA DE TRIAGEM (GET) - Para recrutas externos
     * Versão com Visão de Raio-X para desempacotar objetos JSON aninhados
     */
    async listarQuarentena() {
        try {
            const response = await apiClient.get('/api/users/pending');
            const data = response.data;
            
            // 📡 LOG TÁTICO: Aperte F12 no navegador para ver EXATAMENTE o que o backend mandou
            console.log("📡 [SALA DE TRIAGEM - DADOS BRUTOS]:", data);

            // 🛡️ Busca Inteligente (Procura o Array em vários "envelopes" comuns)
            if (Array.isArray(data)) return data;
            if (data && Array.isArray(data.users)) return data.users;
            if (data && Array.isArray(data.data)) return data.data;
            if (data && Array.isArray(data.pending)) return data.pending;
            
            console.warn("⚠️ [ALERTA]: Dados recebidos, mas nenhum formato de Array reconhecido.");
            return [];
        } catch (error) {
            console.error("❌ [ERRO API]: Falha ao acessar Quarentena:", error);
            toast.error("FALHA AO ACESSAR QUARENTENA.");
            return [];
        }
    },

    /**
     * ✅ APROVAÇÃO TÁTICA (PATCH)
     */
    async aprovarAgente(id) {
        try {
            await apiClient.patch(`/api/users/approve/${id}`);
            toast.success("🛡️ AGENTE APROVADO PARA SERVIÇO ATIVO!");
            return true;
        } catch (error) {
            toast.error("ERRO NA EFETIVAÇÃO DO RECRUTA.");
            return false;
        }
    }
};